import { ContextMenuHandler, type IMenuItem } from "@asup/context-menu";
import { useArsTable } from "./ArsTableContextProvider";
import { ARST_TOGGLE_SIDEBAR } from "./interface";

/**
 * Props for ArsTableContextMenuProvider.
 */
export interface ArsTableContextMenuProviderProps {
  /** Scaffold content to render inside the provider boundary. */
  children: React.ReactNode;
}

/**
 * Wrapper component kept for ArsTable scaffold parity.
 * Per-cell context menus are provided by ArsTableCellContextMenuProvider.
 *
 * @param props - Wrapper props
 * @param props.children - Child scaffold content
 * @returns Wrapped scaffold content
 */
export const ArsTableContextMenuProvider = ({
  children,
}: ArsTableContextMenuProviderProps): React.ReactElement => {
  const { state, dispatch } = useArsTable();

  /**
   * Toggles visibility of the table sidebar.
   */
  const handleToggleSidebar = (): void => {
    /* istanbul ignore else */
    if (state) {
      dispatch({ operation: ARST_TOGGLE_SIDEBAR });
    }
  };

  const contextMenuItems: IMenuItem[] = [
    {
      label: state?.settings.showSidebar ? "Hide sidebar" : "Show sidebar",
      action: handleToggleSidebar,
    },
  ];

  return <ContextMenuHandler menuItems={contextMenuItems}>{children}</ContextMenuHandler>;
};

ArsTableContextMenuProvider.displayName = "ArsTableContextMenuProvider";
